export const buildCustomerString = customer => {
  const { company, email, firstName, lastName } = customer

  if (!firstName && !lastName && !company) {
    return email.length > 18 ? `${email.slice(0, 18)}…` : email
  }

  const name = `${firstName ? firstName : ''} ${lastName ? lastName : ''} ${company ? `, ${company}` : ''}(${email}`

  return name.length > 18 ? `${name.slice(0, 18)}…` : name
}

export const buildCustomerStringFull = customer => {
  const { company, email, firstName, lastName } = customer

  if (!firstName && !lastName && !company) {
    return email
  }

  const name = `${firstName ? firstName : ''} ${lastName ? lastName : ''} ${company ? `, ${company}` : ''}(${email}`

  return name
}
